const mutations = {
  SET_DISCLAIMER (state, { disclaimer }) {
    state.disclaimer = disclaimer
  }
}

export default mutations
